import { NavigationState } from "@shared/models/navigation-state";
import { OrderOwner } from "@order/models/order-owner";

export class OrderCreationNavigationState extends NavigationState {
	readonly className = "OrderCreationNavigationState";
	readonly orderOwner = new OrderOwner();
}
